import { makeStyles } from '@material-ui/core/styles';
import Alert from 'components/CncUI/Alert';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(() => ({
  alert: {
    marginRight: 30,
  },
  title: {
    fontWeight: 700,
    display: 'block',
    marginBottom: 4,
    marginTop: -4,
  },
  closeButton: {
    position: 'absolute',
    top: 13,
    right: 13,
  },
}));

const FailureMessage = ({ title, message, onClose }) => {
  const classes = useStyles();

  return (
    <Alert id="FailureMessage" fullWidth error className={classes.alert}>
      <span className={classes.title}>
        {title || 'Oops! We ran into an issue. Please refresh and try again.'}
      </span>
      {message ||
        `Or please contact our employee help desk for assistance: (818) 860-7756 or employeehelpdesk@castandcrew.com.
        Or for Media Services assistance: (310) 254-1702 or crewportalhelp@mediaservices.com.`}
      {onClose && (
        <IconButton
          className={classes.closeButton}
          size="small"
          aria-label="close"
          color="inherit"
          onClick={onClose}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    </Alert>
  );
};

export default FailureMessage;
